class QuestionBlank extends BD_Question {
	constructor(...args) {
		super(...args);

		this.elms = {
		};
	}

	getEvents() {
		return [
		];
	}

	onCheck(e) { 
	}

	getAnswer(ctx) { 
	}
} 
